export default function HouseIcon() {
  return (
    <img
      src="https://a0.muscache.com/pictures/4d7580e1-4ab2-4d26-a3d6-97f9555ba8f9.jpg"
      className="w-8 h-8"
    ></img>
  );
}
